// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"bf9aa04e","modalBlocker":"a45d8af2","modal":"a79140bd","title":"f5afd4bb","bottomButtons":"a7c23402","modalCancel":"a4675a70"};